module.exports = __webpack_public_path__ + "static/media/sort-arrows-couple-pointing-up-and-down.09b6e33f.svg";